import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

const firebaseConfig = {
  apiKey: import.meta.env.APP_FIREBASE_API_KEY,
  authDomain: import.meta.env.APP_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.APP_FIREBASE_APP_ID,
  measurementId: import.meta.env.APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const getFirebaseConfig = async () => {
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings = {
    minimumFetchIntervalMillis: 0,
    fetchTimeoutMillis: 30000,
  };
  try {
    await fetchAndActivate(remoteConfig);
    const theme = getValue(remoteConfig, import.meta.env.APP_REMOTE_CONFIG ?? 'global_remote_config').asString();
    const config = getValue(remoteConfig, 'web_config').asString();
    const firebaseConfig = getValue(remoteConfig, 'analytics_config').asString();

    const themeObj = theme ? JSON.parse(theme) : {};
    const configObj = config ? JSON.parse(config) : {};
    const analyticsConfigObj = firebaseConfig ? JSON.parse(firebaseConfig) : {};

    useConfigStore.setState((s) => ({
      ...s,
      appConfig: configObj,
      firebaseConfig: firebaseConfig,
    }));
    return { theme: themeObj, appConfig: configObj, analyticsConfig: analyticsConfigObj };
  } catch (error) {
    console.error('Error fetching Firebase remote config:', error);
  }
};

export { app, getFirebaseConfig };
